import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export class PromotionValidators {
  static promoCodeValidator(invalidPromoCode: boolean): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return invalidPromoCode ? {invalidPromoCode: {value: control.value}} : null;
    };
  }
}